import {
    BuildingModalIcon,
    ContractorTitle,
    EmployeesIcon,
    IconPendingToReviewForApprovalCard,
    IconPendingToReviewInformationCard,
    IconPendingToUploadInformationCard,
    SuppliersIcon
} from '../../../../../components/buttons/IconButtons';
import React from 'react';
import {USER_TYPE_MODEL} from '../../../../../enums/userTypeEnum';
import {isEmailFormat} from "../../../../../Apis/functions";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {TABLES} from "../../../../../Apis/Tables";
import { colors } from '../../../../../enums/colors';
/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */

export const WHITE_LIST_MANUAL_MODEL = {
    id: null,
    email: null,
    isValid: function () {
        return this.email !== null && this.email !== '' && isEmailFormat(this.email)
    },
    toRegister: function () {
        return {
            email: this.email
        }
    }
}

export const WHITE_LIST_AUTOMATIC_MODEL = {
    eventId: null,
    file: null,
    toRegister: function ({ eventId, photoPickerFile }) {
        let formData = new FormData();
        formData.append('eventId', eventId);
        formData.append('file', photoPickerFile?.fileSelected);

        return formData;
    },
    isValid: function ({photoPickerFile}) {
        return photoPickerFile?.fileSelected
    }
}

export const RESERVATION_MODEL = {
    id: null,
    name: null,
    isHost: true,
    zoneSelected: null, // step 2
    dateSelected: null, // step 2
    bookingSelected: null, // step 2
    whiteListManual: [WHITE_LIST_MANUAL_MODEL],
    isValid: function () {
        return this.name !== null && this.name !== '';
    },
    isValidStepDetails: function (){
        return this.name != null;
    },
    isValidStepLocation: function (){
        return this.bookingSelected != null;
    },
    toAddEdit: function () {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            code: this.code,
            measurementUnitId: this.measurementUnitId
        }
    },
    isValidWhiteList() {
        return this.whiteListManual.filter(e => !e.isValid()).length === 0;
    },
    toRegisterWhiteList(eventId) {
        const list = this.whiteListManual.filter(e => e.isValid());

        return list.map(e => {
            return {
                eventId: eventId,
                email: e?.email,
                type: RESERVATION_ATTENDANCE_TYPE_MODEL.WHITE_LIST
            }
        });
    },
}

export const TABS_USER_TYPE = [
    {
        id: USER_TYPE_MODEL.EMPLOYEE,
        key: USER_TYPE_MODEL.EMPLOYEE,
        translation: "employee",
        icon: <EmployeesIcon className="btn-icon-svg-20px icon-color-shades-400" />,
        textNoInfo : "search_for_employees"
    },
    {
        id: USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE,
        key: USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE,
        translation: "Contractor",
        icon: <ContractorTitle className="btn-icon-svg-20px icon-color-shades-400" />,
        textNoInfo : "search_for_contractors"
    },
    {
        id: USER_TYPE_MODEL.SUPPLIER_IN_CHARGE,
        key: USER_TYPE_MODEL.SUPPLIER_IN_CHARGE,
        translation: "Suppliers",
        icon: <SuppliersIcon className="btn-icon-svg-20px icon-color-shades-400" />,
        textNoInfo : "search_for_suppliers"
    },
    {
        id: USER_TYPE_MODEL.VISITOR,
        key: USER_TYPE_MODEL.VISITOR,
        translation: "Visitor",
        icon: <BuildingModalIcon className="btn-icon-svg-20px icon-color-shades-400" />,
        textNoInfo : "search_for_visitors"
    },
];

export const TABS_USER_TYPE_MODEL = {
    EMPLOYEE: TABS_USER_TYPE[0],
    CONTRACTOR: TABS_USER_TYPE[1],
    SUPPLIER: TABS_USER_TYPE[2],
    VISITOR: TABS_USER_TYPE[3],
}

export const TABS_WHITE_LIST_MODEL = {
    AUTOMATIC: {
        id: 0,
        key: "AUTOMATIC",
        translation: "automatic"
    },
    MANUAL: {
        id: 1,
        key: "MANUAL",
        translation: "manual",
    }
}

export const TABS_ATTENDANCES_MAIN_TABS_MODEL = {
    ATTENDEES: {
        id: 0,
        key: "ATTENDEES",
        translation: "attendees"
    },
    WHITE_LIST: {
        id: 1,
        key: "WHITE_LIST",
        translation: "white_list",
    }
}

export const RESERVATION_ATTENDANCE_TYPE_MODEL = {
    WHITE_LIST: 'WHITE_LIST'
}

export const getUserTypeCounts = (usersSelected) => {
    const counts = {
        EMPLOYEE: 0,
        VISITOR: 0,
        CONTRACTOR_IN_CHARGE: 0,
        SUPPLIER_IN_CHARGE: 0
    };

    usersSelected.forEach(user => {
        switch (user.userTypeId) {
            case USER_TYPE_MODEL.EMPLOYEE:
                counts.EMPLOYEE++;
                break;
            case USER_TYPE_MODEL.VISITOR:
                counts.VISITOR++;
                break;
            case USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE:
                counts.CONTRACTOR_IN_CHARGE++;
                break;
            case USER_TYPE_MODEL.SUPPLIER_IN_CHARGE:
                counts.SUPPLIER_IN_CHARGE++;
                break;
            default:
                break;
        }
    });

    return counts;
};


export const getTextNoInfoByKey = (key) => {
    const tab = TABS_USER_TYPE.find(item => item.key === key);
    return tab ? tab.textNoInfo : null;
};

export const getUserTypeName = (id, list) => {
    const found = list.find(item => item.id === id);
    return found ? found.name : '';
};

export const STEPS_CREATE_RESERVATIONS = {
    DETAILS: {
        INDEX: 0,
        TRANS: "details",
    },
    SCHEDULE_LOCATION: {
        INDEX: 1,
        TRANS: "schedule_location",
    },
    ATTENDEES_TYPES: {
        INDEX: 2,
        TRANS: "attendees_types",
    },
    WHITE_LIST: {
        INDEX: 3,
        TRANS: "white_list",
    },
    SUMMARY: {
        INDEX: 4,
        TRANS: "summary",
    }
}

export const RESERVATION_USERS_CARD_MODEL = {
    SUMMARY: {
        classCard: "background-shades-50",
        list: [
            {
                id:"UNVERIFIED_ENROLLED_USERS",
                titleTrans: "unverified_enrolled_users",
                titleTransShort: "pending_users",
                statusId: STATUS_MODEL.PENDING_REVIEW,
                total:0,
                cols: "col-4",
                classCard: "card-shades-100",
                Icon:IconPendingToReviewInformationCard,
                prop: "totalPendingValidated",
                model: TABLES.EVENT_ATTENDANCE_LIST_PENDING_VALIDATED,
                color: colors.shades100,
                fontColor: "font-color-shades-700",
                infoColor: "icon-color-shades-700",
            },
            {
                id:"VERIFIED_USERS_NOT_CHECKED_IN",
                titleTrans: "verified_users_not_checked_in",
                titleTransShort: "verified_users",
                statusId: STATUS_MODEL.PENDING_REVIEW,
                total:0,
                cols: "col-4",
                classCard: "card-warning-150-50",
                Icon:IconPendingToUploadInformationCard,
                prop: "totalPendingCheckIn",
                model: TABLES.EVENT_ATTENDANCE_LIST_PENDING_CHECK_IN,
                color: colors.warning100,
                fontColor: "font-color-warning-700",
                infoColor: "icon-color-warning-700",
            },
            {
                id:"VERIFIED_CHECKED_IN_USERS",
                titleTrans: "verified_checked_in_users",
                titleTransShort: "checked_in_users",
                visitorStatusId: STATUS_MODEL.PENDING_REVIEW,
                total:0,
                cols: "col-4",
                classCard: "card-success-150-50",
                Icon:IconPendingToReviewForApprovalCard,
                prop: "totalCheckedIn",
                model: TABLES.EVENT_ATTENDANCE_LIST_TOTAL_CHECK_IN,
                color: colors.success100,
                fontColor: "font-color-success-700",
                infoColor: "icon-color-success-700",
            }
        ]
    }
}

/**
 * Configuration options for Pie Chart (Chart.js).
 *
 * This configuration defines the responsive behavior, legend styling,
 * tooltip customization, and general chart appearance.
 *
 * Features:
 * - Responsive layout with disabled aspect ratio constraint
 * - Bottom-positioned legend with custom styling
 * - Tooltip displaying percentage values instead of raw data
 * - Hidden chart title
 *
 * Tooltip behavior:
 * - Calculates total dataset dynamically
 * - Converts each value into a percentage of the total
 * - Displays formatted percentage with one decimal place
 *
 * @constant {Object} PIE_OPTIONS
 */
export const PIE_OPTIONS = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
        legend: {
            position: 'bottom',

            labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                padding: 10,
                font: { size: 10 },
                boxWidth: 10,
                boxHeight: 10
            }
        },

        tooltip: {
            callbacks: {
                label: (context) => {
                    const data = context.dataset.data || [];
                    const total = data.reduce((a, b) => a + b, 0);

                    const value = context.raw || 0;
                    const percentage = total ? ((value / total) * 100).toFixed(1) : 0;

                    return `${context.label}: ${percentage}%`;
                }
            }
        },

        title: {
            display: false
        }
    }
};
